module.exports = __webpack_public_path__ + "img/Millennium.005f51d2.png";